import * as Cookie from './cookie';
import ApiBuilder from '@ln/personalizacion/api';
import Providers from '@ln/personalizacion/laNacionProvider';
import * as ClearLoQueSigo from './ClearLoQueSigo';

export const init = () => {
    const cookieToken = Cookie.LeerCookie("token");
    
    if (cookieToken  !== "") {
        const lsToken = localStorage.getItem("token");
        if (cookieToken === lsToken) {//Pregunta si la cookie tiene el mismo token que el localstorage
            if (!isSessionDateExpired()) {//Devuelve si la sesion sigue siendo valida
                return true;
            } else {
                clearLocalstorage();
                localStorage.setItem("token",cookieToken);
                localStorage.setItem("sessionCreated",Date.now());
                localStorage.setItem("CDusuarioLogeado", "yes");
                return true;
            }
        } else {
            clearLocalstorage();
            //Se llama al clearCustomDImension porque unicamente se limpia al cambiarse el token y no al deslogearse
            clearCustomDimension();
            localStorage.setItem("token",cookieToken);
            localStorage.setItem("sessionCreated",Date.now());
            localStorage.setItem("CDusuarioLogeado", "yes");
            return true;
        }

    } else {
        clearLocalstorage();
        return false;
    }
    
}
const isSessionDateExpired = () => {
    const sessionCreatedDate = localStorage.getItem("sessionCreated");
    let sessionCacheMiliseconds = 900000; ///TODO:pasar a configuracion
    let dif = 0;

    if (sessionCreatedDate === null) {
        return true;
    } else {
        dif = Date.now() - sessionCreatedDate;
        if (dif < sessionCacheMiliseconds) {
            return false;
        } else {
            return true;
        }
    }
}

const clearLocalstorage = () => {
    
    localStorage.removeItem("token");
    localStorage.removeItem("sugerenciasTitulares");
    localStorage.removeItem("fechaSugerenciaTitulares");
    localStorage.removeItem("CDusuarioLogeado");
    ClearLoQueSigo.clearLS();
    localStorage.removeItem("randomCorteSugerencias");
    localStorage.removeItem("fechaOriginalRandom");
    //remove items
}

const clearCustomDimension = () => {
    //Solo tiene que llamarse al clearCustomDimension cuando cambio el token y no cuando se deslogeo
    localStorage.removeItem("CDcacheCommon");
    localStorage.removeItem("CDusuarioLogeado");
    localStorage.removeItem("CDusuarioRegistrado");
    localStorage.removeItem("CDpayUser");
    localStorage.removeItem("CDsuscriptorType");
    localStorage.removeItem("CDcredentialType");
    localStorage.removeItem("CDuserId");

}

export const initPerso = () => {
    const configProvider = Providers.ConfigProvider;
    return ApiBuilder(configProvider());
    
    //FOR TEST ONLY
    //******************************
    //const usuario = {
    //    token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoiMDYyNjY1MzkyRkVENDRBNjg3Mzc3NENFMUQ5NDcwM0EiLCJpZF92ZXJpZmllciI6IkY4Nzc4M0YxIiwiZXhwIjoxNTE0MjExNjUyfQ.WbMh_4ZmPlWLXmECoRfZWtOyCtVNAtVOIe0Frg-qIyM",
    //    //token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoiODA2RDM5QjFCRDUwNERBOUFFN0Y3RjYwRTExMjEzRUQiLCJpZF92ZXJpZmllciI6IkFFQUQxMDhBIiwiZXhwIjoxNTEyODQ1NzIwfQ.3apuiTeTkcnRsJ7P_JgInnVN2kpAv3kSrgSJ2kEUYCk",
    //    //session: "AEAD108A"
    //    session: "F87783F1"
    //}
    //const APIDOMAIN = "https://personalizacion.lanacion.com.ar/v3";
    //return ApiBuilder(configProvider(APIDOMAIN, usuario));  
}


// WEBPACK FOOTER //
// ./Statics/scripts/common/session.js